The opaque cursor to the webhook request.

This can be used as a subsequent pagination argument.
